export const filtersFunction = (fnString: string) => {
    try {
        // Создаём функцию с одним параметром 'o', тело которой — переданная строка
        const fn = new Function('o', `return (${fnString})`);
        return fn;
    } catch (error) {
        console.error('Failed to create function from string:', error);
        // Возвращаем заглушку, чтобы избежать ошибок при вызове
        return () => false;
    }
};